import { useEffect, useRef, useState } from 'react';
export function useAgentCommands(sessionKey, active, list) {
    const listRef = useRef(list);
    listRef.current = list;
    const [revision, refresh] = useState(0);
    const [directory, setDirectory] = useState({ key: sessionKey, status: 'loading', commands: [] });
    useEffect(() => {
        if (!active)
            return;
        let current = true;
        setDirectory({ key: sessionKey, status: 'loading', commands: [] });
        const load = listRef.current;
        if (!load) {
            setDirectory({ key: sessionKey, status: 'ready', commands: [] });
            return;
        }
        void Promise.resolve().then(load).then((commands) => {
            if (current)
                setDirectory({ key: sessionKey, status: 'ready', commands });
        }, (error) => {
            if (current)
                setDirectory({ key: sessionKey, status: 'failed', commands: [], error: error instanceof Error ? { text: error.message } : { key: 'nativeCommandsLoadFailed' } });
        });
        return () => { current = false; };
    }, [sessionKey, active, revision]);
    return { ...(directory.key === sessionKey ? directory : { status: 'loading', commands: [], error: undefined }), retry: () => refresh((value) => value + 1) };
}
//# sourceMappingURL=useAgentCommands.js.map